import React from 'react'
import classes from 'components/ui/layout/TextPlaceholder/TextPlaceholder.module.scss'

const TextPlaceholder = ({ text }) => {
	return <div className={classes.root}>{text}</div>
}

export default TextPlaceholder
